import type { Move } from '../../../schemas/move';
import { ladroArchetypeMoves } from './archetypes';
import { ladroInitialMoves, ladroStartingAutoMoves, ladroStartingChoiceMoves } from './initial';
import { ladroAdvanced2to5Moves } from './advanced-2-5';
import { ladroAdvanced6to10Moves } from './advanced-6-10';

export {
  ladroArchetypeMoves,
  ladroInitialMoves,
  ladroStartingAutoMoves,
  ladroStartingChoiceMoves,
  ladroAdvanced2to5Moves,
  ladroAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Ladro (manuale V1, sezione "Il Ladro").
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 4 mosse iniziali automatiche + 3 mosse iniziali di scelta (`starting`)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 42 mosse.
 */
export const ladroMoves: readonly Move[] = [
  ...ladroArchetypeMoves,
  ...ladroInitialMoves,
  ...ladroAdvanced2to5Moves,
  ...ladroAdvanced6to10Moves,
];
